<template>
  <q-card flat bordered>
    <div
      v-if="
        !isCapacitor && routeName != 'MultipleChartLayout' && theme == false
      "
      class="row q-pa-xs q-mb-xs"
      :class="this.$q.dark.mode === true ? 'bg-grey-10' : 'bg-grey-1'"
    >
      <div v-if="enableDailyWeeklyIntraday">
        <span class="text-right">
          <router-link
            :to="
              this.$store.state.authenticate.isAuthenticated
                ? !isCapacitor
                  ? routeName == 'Dashboard'
                    ? {
                        path: '/nepse-charts',
                      }
                    : {
                        path: '/nepse-charts',
                        query: { symbol: symbol },
                      }
                  : {
                      path: '/nepse-charts',
                      query: { symbol: symbol },
                    }
                : routeName == 'Dashboard'
                ? {
                    path: '/nepse-charts',
                  }
                : {
                    path: '/nepse-charts',
                    query: { symbol: symbol },
                  }
            "
          >
            <q-btn
              class="q-ma-xs-xs q-px-md"
              outline
              dense
              label="View Large"
              color="purple"
              icon-right="arrow_forward"
              style="font-size: 12px; float: right"
            />
          </router-link>
        </span>
      </div>

      <div class="col-6">
        <q-select
          v-show="routeName == 'Dashboard'"
          outline
          single
          dense
          v-model="selectedSector"
          :options="optionSectors"
          label="Select sector"
          input-debounce="0"
          option-label="name"
          option-value="symbol"
          class="q-mx-sm ellipsis"
          :menu-absolute="true"
          style="width: 150px"
        />
      </div>
      <div class="col-6">
        <router-link
          v-show="routeName == 'Dashboard'"
          :to="
            this.$store.state.authenticate.isAuthenticated
              ? !isCapacitor
                ? routeName == 'Dashboard'
                  ? {
                      path: '/nepse-charts',
                    }
                  : {
                      path: '/nepse-charts',
                      query: { symbol: symbol },
                    }
                : {
                    path: '/nepse-charts',
                    query: { symbol: symbol },
                  }
              : routeName == 'Dashboard'
              ? {
                  path: '/nepse-charts',
                }
              : {
                  path: '/nepse-charts',
                  query: { symbol: symbol },
                }
          "
        >
          <q-btn
            class="q-ma-xs-xs q-px-md"
            outline
            dense
            label="View Large"
            color="purple"
            icon-right="arrow_forward"
            style="font-size: 10px; float: right"
          />
        </router-link>
      </div>
    </div>

    <div v-if="!isCapacitor">
      <TradingView
        v-if="selectedSymbol"
        @selectedSymbol="changeSelectedSymbol($event)"
        preset="mobile"
        :symbol="selectedSymbol"
        height="455"
        :toggles="toggles"
        :backTestdata="backTestdataMini"
        :candleStickData="candleStickData"
        :signalTypedata="signalTypedata"
        :isSignalType="isSignalType"
        :isPMDDSignalType="isPMDDSignalType"
        :signaltype="signaltype"
        :alertOrSignal="alertOrSignal"
        :theme="theme"
        :timePeriod="timePeriod"
        :indicators="indicators"
      />
    </div>
    <div v-if="isCapacitor">
      <TradingView
        v-if="selectedSymbol"
        preset="mobile"
        :symbol="selectedSymbol"
        height="455"
        :toggles="toggles"
        :signalTypedata="signalTypedata"
        :isSignalType="isSignalType"
        :isPMDDSignalType="isPMDDSignalType"
        :signaltype="signaltype"
        :alertOrSignal="alertOrSignal"
        :theme="theme"
        :timePeriod="timePeriod"
        :indicators="indicators"
      />
    </div>
  </q-card>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRoute } from "vue-router";

import TradingView from "./TradingView.vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "TradingViewMini",
  props: {
    indicators: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: Boolean,
      default: false,
    },
    symbol: {
      type: String,
      default: "NEPSE",
    },
    timePeriod: {
      type: String,
      default: "daily",
    },
    enableDailyWeeklyIntraday: {
      type: Boolean,
      default: false,
    },
    backTestdataMini: {
      type: Array,
      default() {
        return ["No Data."];
      },
    },
    candleStickData: {
      type: Array,
      default() {
        return ["No Data."];
      },
    },
    signalTypedata: {
      type: Array,
      default() {
        return ["No Data."];
      },
    },
    isSignalType: {
      type: Boolean,
      default: false,
    },
    isPMDDSignalType: {
      type: Boolean,
      default: false,
    },
    signaltype: {
      type: String,
    },
    alertOrSignal: {
      type: String,
    },
  },
  emits: ["changeActiveSymbol"],
  components: {
    TradingView,
    // TradingViewWeekly,
    // TradingViewIntraday,
  },
  setup(props, context) {
    const isCapacitor = ref(process.env.IS_CAPACITOR);
    const $store = useStore();

    const routeName = computed(() => {
      return useRoute()?.name;
    });

    onMounted(() => {
      if (routeName.value == "Dashboard") {
        selectedSymbol.value = "NEPSE";
        context.emit("changeActiveSymbol", selectedSymbol.value);
        $store.commit("chartsymbol/setSymbol", selectedSymbol.value);
      }
    });

    const toggles = reactive({
      buySell: ref(props.theme ? false : true),
      buySellEarly: ref(false),
      support: ref(props.theme ? false : true),
      resistance: ref(props.theme ? false : true),
      trendline: ref(props.theme ? false : true),
      adjusted: ref(props.theme ? false : true),
    });
    function changeSelectedSymbol(e) {
      context.emit("changeActiveSymbol", e);
      $store.commit("chartsymbol/setSymbol", e);
    }
    if (routeName.value === "Dashboard") {
      toggles.buySell = false;
      toggles.support = props.theme ? false : true;
      toggles.resistance = props.theme ? false : true;
      toggles.trendline = props.theme ? false : true;
    }
    if (props.isSignalType) {
      toggles.buySell = false;
      toggles.support = false;
      toggles.resistance = false;
      toggles.trendline = false;
      toggles.sl_pt = true;
    }
    const selectedSector = ref("");
    let selectedSymbol = ref(props.symbol);
    const optionSectors = ref([
      { symbol: "MICROFININD", name: "Microfinance" },
      { symbol: "LIFEINSUIND", name: "Life Insurance" },
      { symbol: "INVIDX", name: "Investment" },
      { symbol: "FINANCEIND", name: "Finance" },
      { symbol: "OTHERSIND", name: "Others" },
      { symbol: "BANKINGIND", name: "Banking" },
      { symbol: "HOTELIND", name: "Hotels" },
      { symbol: "HYDROPOWIND", name: "Hydro" },
      { symbol: "MANUFACTUREIND", name: "Manufacturing" },
      { symbol: "NONLIFEIND", name: "Non Life " },
      { symbol: "TRADINGIND", name: "Trading" },
      { symbol: "DEVBANKIND", name: "Dev Banks" },
    ]);
    watch(
      () => props.symbol,
      (newValue, oldValue) => {
        selectedSymbol.value = props.symbol;
      }
    );
    watch(selectedSector, (newValue, oldValue) => {
      selectedSymbol.value = selectedSector.value.symbol;
    });
    return {
      changeSelectedSymbol,
      routeName,
      toggles,
      selectedSymbol,
      optionSectors,
      selectedSector,
      isCapacitor,
    };
  },
});
</script>
